import { createEffect } from "effector";
import { addVehicle, deleteVehicle, editVehicle, getFleets, getFleetsByClient } from "../../services/fleetService";
import { EditFleet, Fleet, NewFleet } from "../../types/fleets.types";
import { AppError } from "../../services/classes";

export const getFleetsEffect = createEffect(async () => {
  return await getFleets();
});

export const getFleetsByClientEffect = createEffect<string, Fleet[], AppError>(async (clientId: string) => {
  return await getFleetsByClient(clientId);
});

export const addVehicleEffect = createEffect<NewFleet, Fleet, AppError>(async (fleet: NewFleet) => {
  return await addVehicle(fleet);
});

export const editVehicleEffect = createEffect<EditFleet, Fleet, AppError>(async (fleet: EditFleet) => {
  return await editVehicle(fleet);
});

export const deleteVehicleEffect = createEffect<string, string, AppError>(async (fleetId: string) => {
  await deleteVehicle(fleetId);
  return fleetId;
});
